import React from 'react'
import Layout from '../component/layout'
import NextSeoModule from '../component/next-seo';
import BreadcumbSection from '@/component/breadcumb-section';
import AchiveBox from '@/component/Home/Achive-Box';
import { Poppins, Quicksand } from 'next/font/google';
import Image from 'next/image';
import EducationAboutus from '@/component/about-us/education-aboutus';
import TestimonialSlide from '@/component/Testimonial-Slide';
import LearnsoftStrenght from '@/component/about-us/learnsoft-strenght';
const quickSand =Quicksand({weight:"400", subsets:['latin']});
const popins =Poppins({weight:"400", subsets:['latin']});
export default function About() {
  const TestiData =[  
    {
      img:"/testimonial-img/alex.webp",
      review:"I completed a full stack development course in learnsoft. my course was fully online and I really gained a bunch of knowledge also the trainer was so good and friendly. recorded classes helped a lot with my practise time",
      UserName: "sankar g",
      Course: "Full Stack Development",
    },
    
    {
      img:"/testimonial-img/alex.webp",
      review:`Hi...I've completed DevOps and AWS training in learnsoft. They are perfect in the industry. After completing the course, within 2 weeks they've arranged me a suitable job for me.`,
      UserName: "Sarifa Hyder",
      Course: "Aws",
    },
      
    {
      img:"/testimonial-img/alex.webp",
      review:"I am from pune. On first I was afraid to learn the course in online. later I had a demo session on Azure. From the demo to till my whole course completion I had an amazing experience thanks to ghani",
      UserName: "Nishanthini Praveena",
      Course: "Azure DevOps",
    },
    {
      img:"/testimonial-img/alex.webp",
      review:"I've completed Dynamic 365 training here and placed in a MNC. I can't mention the company name here. Thank you Syed Anwar for guidance.",
      UserName: "Safna Mujib",
      Course: "Dynamic 365",
    },
    {
      img:"/testimonial-img/alex.webp",
      review:
        "Overall PP training was good.Trainer is knowledgeable and we now have recorded sessions available too.Trainer has provided some good real time examples related to IT environment which helped me too.",
      UserName: "Bala Ganesh",
      Course: "Power Platform",
    }, 
    {
      img:"/testimonial-img/alex.webp",
      review:
        "I enquired course of Azure for my daughter they are so nice of me to explain about azure so we’ll good communication with people and be patient to help with people who need more career guidance I am happy to enquiry here",
      UserName: "Venkatesh Parthasarathy",
      Course: "Azure Devops",
    },   
]

  return (
<>
<NextSeoModule
            title="About - learnsoft.org "
            description="Learnsoft is a leading Software Training and Placement institute managed by Software Professionals with more than a 20 years of experience in MNC&apos;s"
            url="about"
            img="/about-img/about-providing"
            breadcrumbs={"Aboutus"}
            
          />
          {/* navbarBorderBottomColor="#ffffff" */}
<Layout  navbarBackgroundColor="#281E1E">

<BreadcumbSection pageTitle={"About Us"}/>

<div className='container'>

<div className={`mt42 df mpdt30 tfdc fac`}>

{/* desktop image */}

<div className='mdn'>
<Image src={"/about-img/about-providing.webp"} alt='Provide-Img' width={"620"} height={"388"} loading='lazy'/>    
</div>  
{/* mobile img */}

<div className='dn mdb'>
<Image src={"/about-img/about-providing.webp"} alt='Provide-Img' width={"300"} height={"188"} loading='lazy'/>    
</div>  

<div className='mmt16 mob-screen'>
<h1 className={`${popins.className} fs-33 mfs-25 mtac`}>We Providing The Best Quality Online Courses</h1>
<p className={`fs-16 tpd20 dim-clr mt16  ${quickSand.className} `}>At learnsoft.org, we're committed to empowering individuals with the skills and knowledge necessary to thrive in today's dynamic world. Whether you're launching your career, improving existing skills, or exploring new interests, we offer a diverse range of courses and programs tailored to your needs.</p>

<div className='mt22 mmt16  df fdc gap24'>
    <div className='circle-box df fac pdl24 mpdl10'>
        <Image src={"/about-img/right-img.webp"} alt='Click-Img' width={"32"} height={"32"} loading='lazy'/>
        <h6 className={`ml13 dg-clr  fs-20 mfs-13 ${popins.className}`}>Flexible Classes</h6> 
    </div>
    <div className='circle-box df fac pdl24 ml100 mml0 mpdl10'>
        <Image src={"/about-img/right-img.webp"} alt='Click-Img' width={"32"} height={"32"} loading='lazy'/>
        <h6 className={`ml13   fs-20 mfs-13 ${popins.className}`}>Offline Class Mode</h6> 
    </div>
    <div className='circle-box df fac pdl24 mpdl10'>
        <Image src={"/about-img/right-img.webp"} alt='Click-Img' width={"32"} height={"32"} loading='lazy'/>
        <h6 className={`ml13 fs-20 mfs-13  ${popins.className}`}>One to One Doubt Clearing Session</h6> 
    </div>
</div>

</div>

</div>

</div>

<EducationAboutus/>
<LearnsoftStrenght/>
{/* <Aboutus /> */}
<AchiveBox/>
<TestimonialSlide TestiData={TestiData}/>
</Layout>

<style jsx>
  {`
  .circle-box{
    width:500px;
   height:58px;
   border-radius:30px;
   background-color:#FDCF74;
    }
    @media only screen and (max-width: 768px){

    .circle-box{
        width:auto;
       height:45px;
       border-radius:23px;
       background-color:#FDCF74;
        }
  }
        @media only screen and (max-width: 1250px){
      .tfdc{
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      }
        
        }

  `}
</style>
</>
  )
}
